import { CmsArticleStatusesEnum } from '~/src/models/enums/cms.enum';
import { getBooleanFromString } from '~/src/repositories/cms/shared/utils/cms.utils';
import type { CmsMappedArticlesInterface } from '~/src/repositories/cms/types/cms.articles.types';

export const getMappedMtsBankData = (data: Array<CmsMappedArticlesInterface | Record<string, never>>) => {
    if (data.length) {
        const newData = data[0];
        if (newData?.status === CmsArticleStatusesEnum.PUBLISHED) {
            const addressIsRequired =
                newData?.attributeCategories?.obshcheye_opisaniye?.attributes?.obyazatelno_zapolneniye_adresa?.value;

            return {
                addressIsRequired: getBooleanFromString(addressIsRequired),
                ogTitle:
                    newData?.attributeCategories?.otobrazheniye_ssylki_v_messendzherakh?.attributes?.ogtitle?.value ||
                    null,
                ogDescription:
                    newData?.attributeCategories?.otobrazheniye_ssylki_v_messendzherakh?.attributes?.ogdescription
                        ?.value || null,
                ogSiteName:
                    newData?.attributeCategories?.otobrazheniye_ssylki_v_messendzherakh?.attributes?.ogsitename
                        ?.value || null,
                region: newData?.attributeCategories?.obshcheye_opisaniye?.attributes?.region?.value || null,
                tariffsAdditionalInfo: newData?.attributeCategories?.for_tariffs_popups?.attributes || {},
                tariff:
                    [
                        {
                            code: newData?.attributeCategories?.umnyy_biznes_start?.code || null,
                            name: newData?.attributeCategories?.umnyy_biznes_start?.name || null,
                            internetAndCalls:
                                newData?.attributeCategories?.umnyy_biznes_start?.attributes?.internet_zvonki?.value ||
                                null,
                            internetAndCallsCrossed:
                                newData?.attributeCategories?.umnyy_biznes_start?.attributes?.internet_zvonki_crossed
                                    ?.value || null,
                            sms: newData?.attributeCategories?.umnyy_biznes_start?.attributes?.sms?.value || null,
                            price: newData?.attributeCategories?.umnyy_biznes_start?.attributes?.price?.value || null,
                            description:
                                newData?.attributeCategories?.umnyy_biznes_start?.attributes?.description?.value ||
                                null,
                        },
                        {
                            code: newData?.attributeCategories?.umnyy_biznes_m?.code || null,
                            name: newData?.attributeCategories?.umnyy_biznes_m?.name || null,
                            internetAndCalls:
                                newData?.attributeCategories?.umnyy_biznes_m?.attributes?.internet_zvonki?.value ||
                                null,
                            internetAndCallsCrossed:
                                newData?.attributeCategories?.umnyy_biznes_m?.attributes?.internet_zvonki_crossed
                                    ?.value || null,
                            sms: newData?.attributeCategories?.umnyy_biznes_m?.attributes?.sms?.value || null,
                            price: newData?.attributeCategories?.umnyy_biznes_m?.attributes?.price?.value || null,
                            description:
                                newData?.attributeCategories?.umnyy_biznes_m?.attributes?.description?.value || null,
                        },
                        {
                            code: newData?.attributeCategories?.umnyy_biznes_l?.code || null,
                            name: newData?.attributeCategories?.umnyy_biznes_l?.name || null,
                            internetAndCalls:
                                newData?.attributeCategories?.umnyy_biznes_l?.attributes?.internet_zvonki?.value ||
                                null,
                            internetAndCallsCrossed:
                                newData?.attributeCategories?.umnyy_biznes_l?.attributes?.internet_zvonki_crossed
                                    ?.value || null,
                            sms: newData?.attributeCategories?.umnyy_biznes_l?.attributes?.sms?.value || null,
                            price: newData?.attributeCategories?.umnyy_biznes_l?.attributes?.price?.value || null,
                            description:
                                newData?.attributeCategories?.umnyy_biznes_l?.attributes?.description?.value || null,
                        },
                        {
                            code: newData?.attributeCategories?.umnyy_biznes_xl?.code || null,
                            name: newData?.attributeCategories?.umnyy_biznes_xl?.name || null,
                            internetAndCalls:
                                newData?.attributeCategories?.umnyy_biznes_xl?.attributes?.internet_zvonki?.value ||
                                null,
                            internetAndCallsCrossed:
                                newData?.attributeCategories?.umnyy_biznes_xl?.attributes?.internet_zvonki_crossed
                                    ?.value || null,
                            sms: newData?.attributeCategories?.umnyy_biznes_xl?.attributes?.sms?.value || null,
                            price: newData?.attributeCategories?.umnyy_biznes_xl?.attributes?.price?.value || null,
                            description:
                                newData?.attributeCategories?.umnyy_biznes_xl?.attributes?.description?.value || null,
                        },
                    ] || [],
            };
        }
        return {};
    }
    return {};
};
